import { LoadableAfterPaint } from '@confluence/loadable';

export const ForgeGlobalSettingsExtensionPoint = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-GlobalSettings" */ './GlobalSettings.tsx'))
			.GlobalSettings,
});
